// extracted by mini-css-extract-plugin
export default {"tasks":"dM-z","task":"eM-z","svg":"fM-z","text":"gM-z"};